export default "__VITE_ASSET__CiqhbeHX__"